import React from "react";
import { keyframes } from '@emotion/react';
import { Grid, Box, Typography } from '@mui/material';
import { Link as LinkIcon } from '@mui/icons-material';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const UpiPayment = () => {
 


const navigate = useNavigate();

// Dot animations
const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const hoverEffect = {
  transform: 'scale(1.05)',
  transition: 'transform 0.3s ease',
};

const features = [
  {
    icon: "🕒",
    title: "24x7 Availability",
    description:
      "Transfer money anytime, anywhere – even on holidays and weekends. UPI never sleeps.",
    color: "#0037CC",
  },
  {
    icon: "🛡️",
    title: "Bank-Grade Security",
    description:
      "Multi-layer security with UPI PIN, device binding, and encrypted transactions for complete peace of mind.",
    color: "#00A04E",
  },
  {
    icon: "⚡",
    title: "Instant Transfers",
    description:
      "Money reaches the recipient's account within seconds. No waiting, no delays.",
    color: "#FFB800",
  },
  {
    icon: "🏦",
    title: "Direct Bank Transfer",
    description:
      "Money moves directly between bank accounts with no need for intermediaries.",
    color: "#0037CC",
  },
  {
    icon: "🔳",
    title: "QR Code Payments",
    description:
      "Simply scan and pay. Perfect for merchants, service providers, and P2P transfers.",
    color: "#00A04E",
  },
  {
    icon: "💸",
    title: "Low or No Fees",
    description:
      "Most UPI transactions are free or have negligible charges, making it cost-effective.",
    color: "#FFB800",
  },
];

 const steps = [
   {
    id: '01',
    title: 'Download TA One App',
    description:
      "Enjoy fast and secure UPI payments with the TA One app — your all-in-one wallet.",
    points: [
      'Available on Android & iOS',
      'Free to download',
      'Multiple options available',
    ],
    icon: <SmartphoneIcon sx={{ fontSize: 60, color: '#fff' }} />,
    iconBg: 'linear-gradient(180deg, #0052D4 0%, #2E8BFF 100%)',
    iconColor: '#0052D4',
  },
  {
    id: '02',
    title: 'Link Your Bank Account',
    description:
      'Connect your bank account securely within the app. Your bank details are encrypted and protected.',
    points: [
      'Bank-grade encryption',
      'Multiple account support',
      'Instant verification',
    ],
    icon: <LinkIcon sx={{ fontSize: 60, color: '#fff' }} />,
    iconBg: 'linear-gradient(180deg, #00B464 0%, #22D07A 100%)',
    iconColor: '#00B464',
  },
  {
    id: '03',
    title: 'Create UPI PIN',
    description:
      'Set up your unique UPI PIN for secure transactions. This PIN ensures only you can authorize payments.',
    points: [
      '4 or 6 digit PIN',
      'Secure authentication',
      'Easy to remember',
    ],
    icon: <CreditCardIcon sx={{ fontSize: 60, color: '#fff' }} />,
    iconBg: 'linear-gradient(180deg, #0052D4 0%, #2E8BFF 100%)',
    iconColor: '#0052D4',
  },
  {
    id: '04',
    title: 'Start Transacting',
    description:
      "You're all set! Start sending money, paying bills, and making purchases with just a few taps.",
    points: [
      'Instant payments',
      '24x7 availability',
      'Multiple payment methods',
    ],
    icon: <CheckCircleIcon sx={{ fontSize: 60, color: '#fff' }} />,
    iconBg: 'linear-gradient(180deg, #00B464 0%, #22D07A 100%)',
    iconColor: '#00B464',
  },
];

  return (
     <>
  <div
      style={{
        background: "linear-gradient(135deg, #fcf8e5ff, #ecfdf5)",
        color: "Black",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "40px 20px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "70vh",
          gap: "40px",
          flexWrap: "wrap",
        }}
      >
        {/* Left Section with animation */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          style={{ flex: "1 1 500px", minWidth: "280px" }}
        >
          <div style={{ opacity: 0.8, marginBottom: "10px", fontWeight: "500" }}>
            ⚡ Revolutionary UPI Payments
          </div>
          <h1
            style={{
              fontSize: "40px",
              margin: 0,
              lineHeight: "1.2",
            }}
          >
            <span style={{ fontWeight: 700 }}>UPI Payments</span>{" "}
            <span style={{ fontWeight: 700, opacity: 0.7, color: "green" }}>
              Revolutionized
            </span>
          </h1>
          <p style={{ marginTop: "20px", fontSize: "18px", opacity: 0.85 }}>
            Experience the future of digital transactions with Unified Payments Interface (UPI) – instant, secure, and available 24x7.
          </p>
          <p style={{ fontSize: "16px", opacity: 0.75 }}>
            Unlock seamless financial connectivity with zero transaction fees, lightning-fast transfers, and enterprise-grade security.
          </p>

          {/* Buttons */}
          <div style={{ marginTop: "30px", display: "flex", flexWrap: "wrap", gap: "16px" }}>
         <button
  onClick={() => navigate("/download")}
  style={{
    background: "#00B464",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "14px 24px",
    fontSize: "16px",
    fontWeight: 600,
    cursor: "pointer",
  }}
>
  Get Started Now →
</button>
          </div>
        </motion.div>

        {/* Right Section (Image) with animation */}
      {/* Right Section (Image) with zoom-in animation */}
<motion.div
  initial={{ scale: 0.8, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  style={{
    flex: "1 1 400px",
    minWidth: "280px",
    position: "relative",
    textAlign: "center",
  }}
>
  <img
    src="/upipaymentimg.png"
    alt="UPI App"
    style={{
      maxWidth: "120%",
      height: "400px",
      borderRadius: "20px",
    }}
  />
</motion.div>

      </div>
    </div>


   <section style={{ background: "#F9FAFB", padding: "80px 0" }}>
  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 20px",
      fontFamily: "'Segoe UI', sans-serif",
    }}
  >
    <h2
      style={{
        fontSize: "36px",
        fontWeight: 700,
        color: "#111827",
        textAlign: "center",
      }}
    >
      Why Choose UPI?
    </h2>
    <p
      style={{
        fontSize: "18px",
        color: "#6B7280",
        maxWidth: "800px",
        margin: "10px auto 50px",
        textAlign: "center",
      }}
    >
      UPI has revolutionized digital payments in India with its seamless,
      secure, and instant transaction capabilities. Here's what makes it
      special.
    </p>

    {/* Responsive Card Grid */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "24px",
      }}
    >
      {features.map((feature, index) => (
        <div
          key={index}
          style={{
            background: "#fff",
            padding: "30px",
            borderRadius: "12px",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            textAlign: "left",
            transform: "translateY(0)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            animation: "fadeInUp 0.6s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
          }}
        >
          <div style={{ fontSize: "28px", color: feature.color }}>
            {feature.icon}
          </div>
          <h3
            style={{
              fontSize: "20px",
              fontWeight: 600,
              marginTop: "10px",
              color: "#111827",
            }}
          >
            {feature.title}
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#6B7280",
              marginTop: "6px",
            }}
          >
            {feature.description}
          </p>
        </div>
      ))}
    </div>
  </div>

  {/* Animation Keyframes */}
  <style>
    {`
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `}
  </style>
</section>

<section style={{ background: "#F9FAFB", padding: "80px 0" }}>
  <Box sx={{ maxWidth: '1200px', mx: 'auto', px: 2 }}>
    <Typography variant="h4" align="center" sx={{ fontWeight: 600, mb: 4 }}>
      How UPI Works
    </Typography>
    <p
      style={{
        fontSize: "18px",
        color: "#6B7280",
        maxWidth: "800px",
        margin: "10px auto 50px",
        textAlign: "center",
      }}
    >
      Getting started with UPI is simple and takes just a few minutes. Follow these easy steps to join millions of users making seamless digital payments.
    </p>

    {steps.map((step, index) => {
      const isEven = index % 2 === 1;
      return (
       <Box
  key={step.id}
  sx={{
    backgroundColor: '#fff',
    borderRadius: 4,
    boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    mb: 4,
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'translateY(-6px) scale(1.02)',
      boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
    },
  }}
>

          <Grid container direction={isEven ? 'row-reverse' : 'row'}>
            {/* Icon Side */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: '#E9F2FF',
                  height: '100%',
                  p: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                }}
              >
                <Box
                  sx={{
                    width: 140,
                    height: 140,
                    borderRadius: 4,
                    background: step.iconBg,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    animation: `${pulse} 2s ease-in-out infinite`,
                    '&:hover': hoverEffect,
                  }}
                >
                  {step.icon}

                  {/* Yellow dot */}
                  <Box
                    sx={{
                      width: 18,
                      height: 18,
                      backgroundColor: '#FFCB00',
                      borderRadius: '50%',
                      position: 'absolute',
                      top: -9,
                      right: -9,
                      animation: `${bounce} 1.8s ease-in-out infinite`,
                    }}
                  />

                  {/* Dark dot */}
                  <Box
                    sx={{
                      width: 18,
                      height: 18,
                      backgroundColor: '#002D62',
                      borderRadius: '50%',
                      position: 'absolute',
                      bottom: -7,
                      left: -7,
                      animation: `${bounce} 2.2s ease-in-out infinite`,
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Text Side */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: { xs: 3, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography
                    sx={{
                      fontSize: '42px',
                      fontWeight: 700,
                      color: '#D2DBEE',
                      mr: 1,
                    }}
                  >
                    {step.id}
                  </Typography>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: 2,
                      backgroundColor: step.iconColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {React.cloneElement(step.icon, {
                      sx: { fontSize: 24, color: '#fff' },
                    })}
                  </Box>
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  {step.title}
                </Typography>
                <Typography sx={{ color: '#555', fontSize: '15px', mb: 2 }}>
                  {step.description}
                </Typography>

                <Box component="ul" sx={{ pl: 3, m: 0, color: '#2E7D32' }}>
                  {step.points.map((point, idx) => (
                    <Box
                      key={idx}
                      component="li"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '15px',
                        mb: 1,
                        color: '#2E7D32',
                      }}
                    >
                      <CheckCircleIcon sx={{ fontSize: 18, mr: 1 }} />
                      {point}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      );
    })}
  </Box>
</section>

   </>
  );
};
 
export default UpiPayment;
 